import { useApiDelete } from '@sierralabs/core-ui';
export function useDeleteComponent(id) {
    const { data, isLoading, error, del } = useApiDelete(`components/${id}`);
    return {
        deletedComponent: data,
        deletingComponent: isLoading,
        deleteError: error,
        deleteComponent: del
    };
}
//# sourceMappingURL=useDeleteComponent.js.map